import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    display: none;

    @media (max-width: ${theme.sz.lg}) {
      display: block;
      position: sticky;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      padding: 14px ${theme.sz.s5} ${theme.sz.s5};
      box-shadow: 0 -2.25px 4px rgba(0, 0, 0, 0.06);
      z-index: ${theme.zi.z1};
    }
  `,
);

export const Cta = styled.button(
  ({ theme }) => css`
    display: block;
    width: 100%;
    background: ${theme.co.primary20};
    color: ${theme.co.secondary0};
    font-weight: 800;
    font-size: 1.125rem;
    text-align: center;
    padding: ${theme.sz.s4};
    border: none;
    border-radius: ${theme.sz.s3};
    box-shadow: 0 4px 0 ${theme.co.primary0};
    cursor: pointer;
  `,
);

export const TrustRow = styled.div(
  ({ theme }) => css`
    text-align: center;
    font-size: 0.75rem;
    color: ${theme.co.secondary50};
    font-weight: 500;
    margin-top: 10px;

    span + span::before {
      content: '•';
      margin: 0 6px;
      color: ${theme.co.secondary60};
    }
  `,
);
